import CitySEOHead from "@/components/feature/CitySEOHead";
import TitusvilleHeroSection from "./components/HeroSection";
import TitusvilleStickyNav from "./components/StickyNav";
import TitusvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import TitusvilleServicesSection from "./components/ServicesSection";
import TitusvilleLocalAreaSection from "./components/LocalAreaSection";
import TitusvilleTestimonialsSection from "./components/TestimonialsSection";
import TitusvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TitusvilleComparisonSection from "./components/ComparisonSection";
import TitusvilleMistakesSection from "./components/MistakesSection";
import TitusvilleHowItWorksSection from "./components/HowItWorksSection";
import TitusvilleFAQSection, { faqs } from "./components/FAQSection";
import TitusvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TitusvilleFinalCTA from "./components/FinalCTA";
import TitusvilleTravelTimingSection from "./components/TravelTimingSection";
import TitusvilleDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Titusville, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Titusville, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Titusville, Kennedy Space Center, Mims, and northern Brevard County travelers needing urgent, fast, or same-day passport help.";

const areaServedList = [
  { "@type": "City", name: "Titusville" },
  { "@type": "City", name: "Port St. John" },
  { "@type": "City", name: "Mims" },
  { "@type": "City", name: "Cape Canaveral" },
  { "@type": "City", name: "Cocoa" },
  { "@type": "City", name: "Scottsmoor" },
  { "@type": "City", name: "Merritt Island" },
  { "@type": "AdministrativeArea", name: "Brevard County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Titusville, Kennedy Space Center, Cape Canaveral, and Brevard County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function TitusvillePage() {
  return (
    <>
      <CitySEOHead
        city="Titusville"
        state="Florida"
        stateAbbr="FL"
        route="/titusville"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Titusville, Florida"
        geoPosition="28.6122;-80.8076"
        keywords="expedited passport Titusville, emergency passport Titusville FL, same day passport Titusville, fast passport Florida, passport renewal Titusville, Titusville passport courier, KSC passport, Kennedy Space Center passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-16"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
      />

      <div className="font-sans">
        <TitusvilleHeroSection />
        <TitusvilleStickyNav />
        <TitusvilleProcessingTimeSection />
        <TitusvilleLocalAreaSection />
        <TitusvilleServicesSection />
        <TitusvilleTravelTimingSection />
        <TitusvilleDestinationsSection />
        <TitusvilleTestimonialsSection />
        <TitusvilleAcceptanceFacilitiesSection />
        <TitusvilleComparisonSection />
        <TitusvilleMistakesSection />
        <TitusvilleHowItWorksSection />
        <TitusvilleFAQSection />
        <TitusvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/titusville" state="FL" />
        <TitusvilleFinalCTA />
      </div>
    </>
  );
}